import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eacb66c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "border-r" }
const _hoisted_2 = { class: "border-r" }
const _hoisted_3 = { class: "border-r" }
const _hoisted_4 = { class: "border-r" }

import { IHeadersTable } from '@/types';
    import { withDefaults, ref, watch, onMounted, computed } from 'vue';
    import 'vue-good-table-next/dist/vue-good-table-next.css';
    import { VueGoodTable } from 'vue-good-table-next';
    
    import { MoleculeFilters, MoleculePagination } from '@/components/molecules';
    import {
      AtomBadge,
      AtomPhasedProgress,
      AtomInput,
      AtomInputMoney,
      AtomSelect,
      AtomCheckBox,
    
      LoaderIcon
    } from '../atoms';
    
    interface IProps {
      headers: Array<IHeadersTable>;
      items: any[];
      filters?: boolean;
      enableOptions?: boolean;
      disableSelectInfo?: boolean;
      selectOnCheckboxOnly?: boolean;
      textEmpty?: string;
      selectedClass?: string;
      indexSelect?: number;
      perPage?: number;
      page?: number;
      totalItems?: number;
      update?: boolean;
      pagination?: boolean;
      loading?: boolean;
      itemSelect?: any;
      hasOptions?: boolean;
      isFinanceira?: boolean;
      // checkbox?: boolean;
    }
    
export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeTableAddModal',
  props: {
    headers: {},
    items: {},
    filters: { type: Boolean, default: false },
    enableOptions: { type: Boolean },
    disableSelectInfo: { type: Boolean },
    selectOnCheckboxOnly: { type: Boolean },
    textEmpty: { default: 'Sem informações para exibição' },
    selectedClass: { default: '' },
    indexSelect: {},
    perPage: { default: 10 },
    page: { default: 1 },
    totalItems: { default: 0 },
    update: { type: Boolean, default: false },
    pagination: { type: Boolean, default: true },
    loading: { type: Boolean },
    itemSelect: {},
    hasOptions: { type: Boolean, default: true },
    isFinanceira: { type: Boolean }
  },
  emits: [
      'handleUpload',
      'rowClick',
      'changePerPage',
      'changePage',
      'updateRow',
      'searching',
      'handleSort',
      'blur'
    ],
  setup(__props: any, { emit: __emit }) {

    const emit = __emit;
    const table = ref(null);
    const lengthItems = computed(() => {
      return Math.ceil(props.totalItems / perPageTable.value)
    });
    const search = ref<string>('');
    const props = __props;
    
    const updateValues = ref<any>({});
    const page = ref(1);
    const perPageTable = ref(10);
    // let badges = props.headers.filter((f) => f.type == 'badge');
    
    let pagination = {
      enabled: true,
      mode: 'records',
      perPage: perPageTable.value,
    };
    
    const computedItems = computed(() => {
      return props.items.filter(x => x.archived ? x.archived === 0 : true)
    })
    
    onMounted(() => {
      page.value = props.page;
      perPageTable.value = props.perPage;
    
      if (props.itemSelect) {
        props.headers
          .filter((f) => !!f.update)
          .map((x) => {
            updateValues.value[String(x.update)] = props.itemSelect[String(x.update)];
          });
      }
    });
    watch(
      () => page.value,
      () => {
        emit('changePage', page.value);
      }
    );
    watch(
      () => props.page,
      () => {
        page.value = props.page;
      }
    );
    watch(
      () => perPageTable.value,
      () => {
        emit('changePerPage', perPageTable.value);
      }
    );
    watch(
      () => props.perPage,
      () => {
        perPageTable.value = props.perPage;
      }
    );
    watch(
      () => updateValues.value,
      () => {
        emit('updateRow', updateValues.value);
      },
      { deep: true }
    );
    
    watch(
      () => search.value,
      () => {
        emit('searching', search.value);
      }
    );
    
    function onSortChange(params) {
      emit('handleSort', {
        type: params[0].type,
        field: params[0].field,
      });
    }
    
    watch(
      () => props.itemSelect,
      () => {
        if (props.itemSelect) {
          updateValues.value = {};
    
          const data: any = {};
    
          props.headers
            .filter((f) => !!f.update)
            .map((x) => {
              data[String(x.update)] = props.itemSelect[String(x.update)];
            });
          updateValues.value = data;
        }
      }
    );
    
    function handleBlur(event) {
      emit('blur', event)
    }
    
    function rowStyleClassFn(row) {
      let clss = ` ${row.archived != undefined ? (row.archived == 1 ? 'inactive' : 'active') : ''} row-table ${props.selectedClass
        } ${props.indexSelect && row.id == props.indexSelect ? 'selected-row-sp' : ''} ${props.indexSelect && row.id == props.indexSelect && props.isFinanceira ? 'background-orange' : ''}`;
    
      return clss;
    }
    
    function validLine(row) {
      return props.indexSelect && row.id == props.indexSelect;
    }
    function handleUpload() {
      emit('handleUpload');
    }
    function onRowClick(params) {
      emit('rowClick', params);
    }
    function selectionChanged(params) {
      console.log('selected row', params);
    }
  
  
  const header = ([
    { label: 'Orientação', field: 'orientation' },
    { label: 'Margem', field: 'margin' },
    { label: 'Marca', field: 'brand'},
    { label: 'Gatilho', field: 'trigger'},
    { label: 'Sazonalidade', field: 'seasonality'},
    { label: 'Periodo', field: 'period'},
    { label: 'Revenda', field: 'resale'},
    { label: 'Depósito', field: 'deposit'},
    { label: 'Obrigatório', field: 'mandatory'},
    { label: 'Cross', field: 'croos'},
  ]);
  const items = ref<any[]>([
    {info:"Marca"}, 
    {info:"R$ 1.000,00"},
    { info:"BlueBird"}, 
    {info:"exibir"},
    { info:"Exibir"},
    { info:"01/01/2023"},
    {info:"-"}, 
    {info:"123b"},
  ]);
  const totalRowsSmall = ref(0);
    
return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_col),
    _createVNode(_component_v_table, { class: "border-table" }, {
      default: _withCtx(() => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(header, (item, index) => {
              return _createElementVNode("th", {
                class: "text-dark border-r",
                key: String(index)
              }, [
                _createElementVNode("strong", null, _toDisplayString(item.label), 1)
              ])
            }), 64))
          ])
        ]),
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
              return (_openBlock(), _createElementBlock("td", {
                class: "border-r",
                key: String(index)
              }, _toDisplayString(item.info), 1))
            }), 128)),
            _createElementVNode("td", _hoisted_1, [
              _createVNode(_unref(AtomCheckBox))
            ]),
            _createElementVNode("td", _hoisted_2, [
              _createVNode(_unref(AtomCheckBox))
            ])
          ]),
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
              return (_openBlock(), _createElementBlock("td", {
                class: "border-r",
                key: String(index)
              }, _toDisplayString(item.info), 1))
            }), 128)),
            _createElementVNode("td", _hoisted_3, [
              _createVNode(_unref(AtomCheckBox))
            ]),
            _createElementVNode("td", _hoisted_4, [
              _createVNode(_unref(AtomCheckBox))
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})